<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CXZARv/tc-custom/9781473895140.jpg?1704293407764" alt="This image is the cover for the book Sensory History of Ancient Warfare"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sensory History of Ancient Warfare
      </h1>
      <p class="bookDescription body article font2">
        <p>How can we attempt to understand the experience of those involved in ancient battles, sieges and campaigns? What was the visual impact of seeing the massed ranks of the enemy approaching or the sky darkened with their arrows? How did it feel to be trapped in the press of bodies as phalanxes clashed shield to shield? What of the taste of dust on the march or the smell of split blood and entrails? What of the rumble of approaching cavalry, the clash of iron weapons and the screams of the dying? The assault on all five senses which must have occurred is the subject of this innovative book.  Sensory history is a new approach that attempts to understand the full spectrum of the experience of the participants in history. Conor Whately is the first to apply the discipline in a dedicated study of warfare in the classical world. He draws on literary, archaeological, reconstructive and comparative evidence to understand the human experience of the ancient battlefield in unprecedented depth.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Conor Whately
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?263a5cbe